import "./styles.scss";
import { useFormatter } from "@shared/hooks/shared";
import React, { memo } from "react";
import { useIntl } from "react-intl";

import { useAllBonuses } from "./api/get-all-bonuses";

export const BonusTable = memo(() => {
  const intl = useIntl();
  const { bonuses } = useAllBonuses();
  const $f = useFormatter();

  const bonusIssuedAt = (timestamp: number) => {
    const dateIssued = new Date(timestamp * 1000);

    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    } as const;

    return dateIssued.toLocaleString(undefined, options);
  };

  if (!bonuses) {
    return null;
  }

  return (
    <div className="bonus-table">
      <div className="flex-table">
        <div className="flex-row">
          <div className="flex-header">
            {intl.formatMessage({
              id: "date",
            })}
          </div>
          <div className="flex-header">
            {intl.formatMessage({
              id: "boilerplate.components.ModalRoom.BonusBalance",
            })}
          </div>
          <div className="flex-header">
            {intl.formatMessage({
              id: "boilerplate.components.BonusModal.Amount",
            })}
          </div>
          <div className="flex-header">
            {intl.formatMessage({
              id: "wager",
            })}
          </div>
          <div className="flex-header">
            {intl.formatMessage({
              id: "status",
            })}
          </div>
        </div>
        {bonuses?.map((bonus) => {
          return (
            <div className="flex-row" key={bonus.issuedAt}>
              <div className="flex-cell">{bonusIssuedAt(bonus.issuedAt)}</div>
              <div className="flex-cell">{bonus.type}</div>
              <div className="flex-cell">
                {$f.formatMoney($f.toMoney(bonus.amount))}
              </div>
              <div className="flex-cell">
                {$f.formatMoney($f.toMoney(bonus.wager))}
              </div>
              <div className="flex-cell">
                {intl.formatMessage({ id: bonus.status })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});

BonusTable.displayName = "BonusTable";
